import React from 'react'
import Header from '../main/Header'
import Footer from '../main/Footer'

export default function About() {
    return (
        <>
            <Header />
            <section className="page-title">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <div className="breadcrumbs-wrap">
                                <h1 className="breadcrumb-title">About Our Institute </h1>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <a href="#">Home</a>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            About Us
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="pt-0">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="list_facts_wrap">
                                <div className="sec-heading mb-3">
                                    <h2>
                                        Know about <span className="theme-cl">e-Learn</span> learning
                                        platform
                                    </h2>
                                </div>
                                <div className="list_facts">
                                    <div className="list_facts_icons">
                                        <i className="ti-desktop" />
                                    </div>
                                    <div className="list_facts_caption">
                                        <h4>Nemo enim ipsam voluptatem quia.</h4>
                                        <p>
                                            No one rejects, dislikes, or avoids pleasure itself, because it
                                            is pleasure
                                        </p>
                                    </div>
                                </div>
                                <div className="list_facts">
                                    <div className="list_facts_icons">
                                        <i className="ti-heart" />
                                    </div>
                                    <div className="list_facts_caption">
                                        <h4>Nemo enim ipsam voluptatem quia.</h4>
                                        <p>
                                            No one rejects, dislikes, or avoids pleasure itself, because it
                                            is pleasure
                                        </p>
                                    </div>
                                </div>
                                <div className="list_facts">
                                    <div className="list_facts_icons">
                                        <i className="ti-harddrives" />
                                    </div>
                                    <div className="list_facts_caption">
                                        <h4>Nemo enim ipsam voluptatem quia.</h4>
                                        <p>
                                            No one rejects, dislikes, or avoids pleasure itself, because it
                                            is pleasure
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <a href="#" className="btn btn-modern">
                                Know More
                                <span>
                                    <i className="ti-arrow-right" />
                                </span>
                            </a>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="list_facts_wrap_img">
                                <img src="assets/img/edu_2.png" className="img-fluid" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="mission-vision-container">
                <div className="sec-heading center">
                    <p>Our &amp; Goals</p>
                    <h2>
                        <span className="theme-cl">National</span> Vision & Mission
                    </h2>
                </div>
                <div className="row">
                    <div className="col-md-6 mb-4">
                        <div className="mission-vision-card">
                            <div className="mission-vision-content">
                                <h3 className="mission-vision-title">Our Mission</h3>
                                <p className="mission-vision-description">
                                    At National Computer Classes, our mission is to empower individuals
                                    with the skills needed to thrive in the digital age. We aim to
                                    provide high-quality training in web design, web development, app
                                    development, and accounting, helping students achieve their career
                                    goals.
                                </p>
                            </div>
                            <div className="mission-vision-image">
                                <img
                                    alt="Mission"
                                    className="img-fluid"
                                    src="assets/images/mission.jpg"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mb-4">
                        <div className="mission-vision-card">
                            <div className="mission-vision-content">
                                <h3 className="mission-vision-title">Our Vision</h3>
                                <p className="mission-vision-description">
                                    Our vision is to become a leading educational institution that
                                    fosters digital literacy and innovation. We envision a world where
                                    everyone has the skills to succeed in a technology-driven future,
                                    and we are dedicated to shaping the next generation of professionals
                                    in the tech industry.
                                </p>
                            </div>
                            <div className="mission-vision-image">
                                <img
                                    alt="Vision"
                                    className="img-fluid"
                                    src="assets/images/vision.jpg"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>

    )
}
